import { api } from "@/api";
import { BaseQuery, QueryConfig, QueryResponse, QueryResult } from "@/shared/types/base";
import { RegistroAuditoria, TipoAuditoria } from "@/shared/types/registro-auditoria";
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface RegistroAuditoriaQuery extends BaseQuery{
    desde?:string,
    hasta?:string,
    tipoAuditoria?:TipoAuditoria,
    nombreUsuario?:string,
    nombreTabla?:string,
    columnasAfectadas?:string,
    clavePrimaria?:string
}

export async function getAllRegistroAuditorias(query?: RegistroAuditoriaQuery):Promise<QueryResponse<RegistroAuditoria>> {
    await sleep(1000);

    const response = await api.get("auditoria", { params: removeNullOrEmptyKeys(query) });
    const data:QueryResponse = response.data;

    data.result = data.result.map(ra=>({
        ...ra,
        clavePrimaria:JSON.parse(ra.clavePrimaria),
        columnasAfectadas:JSON.parse(ra.columnasAfectadas),
        valoresAnteriores:JSON.parse(ra.valoresAnteriores),
        valoresNuevos:JSON.parse(ra.valoresNuevos)
    }))

    return data;
}

export function useGetAllRegistroAuditoriasQuery(query: RegistroAuditoriaQuery = {}, queryConfig: QueryConfig<QueryResponse<RegistroAuditoria>> = {}){
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getAllRegistroAuditorias(query),
        queryKey: ["auditoria", query]
    })
}

export interface GetAllRegistroAuditoriasQueryProps{
    query:RegistroAuditoriaQuery,
    queryConfig?: QueryConfig<QueryResponse<RegistroAuditoria>>,
    children:(queryResult:QueryResult<QueryResponse<RegistroAuditoria>>)=>ReactNode
}

export function GetAllRegistroAuditoriasQuery({
    query,
    queryConfig,
    children
}:GetAllRegistroAuditoriasQueryProps){
    const queryResult = useGetAllRegistroAuditoriasQuery(query, queryConfig);
    return children&&children(queryResult);
}